import FormatListBulleted from '@mui/icons-material/FormatListBulleted';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function FormatListBulletedIcon(props: FixMe) {
  return <FormatListBulleted {...props} />;
}

export default FormatListBulletedIcon;
